import { Component, OnInit,  Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { AppService } from '../../../app.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { NotificationsService } from 'angular2-notifications';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { GenericIdName } from '../setup-implement/setup-implement.model';
import { CustomerSelectItem, EquipmentSelectItem } from '../setup-equipment/setup-equipment.model';
import { FavouriteDialogService } from '../favourite-dialog/favourite-dialog.service';
import { GETSetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { JobsiteSelectionFilter,  } from '../favourite-dialog/favourite-dialog-modal';
import { EmailLogOrderBy } from '../emailfaxlog/email-fax-log.model';
import { EmailFaxLogRowViewModel, SearchEmailFaxLogItem, SortOptions } from './email-fax-log.model';
import { EmailFaxLogService } from './email-fax-log.service';
import { SelectionModel } from '@angular/cdk/collections';
import { FormControl } from '@angular/forms';
import moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { CryptoService } from '../../../../app/services/crypto.service';
@Component({
  selector: 'app-emailfaxlog',
  templateUrl: './emailfaxlog.component.html',
  styleUrls: ['./emailfaxlog.component.scss'],
  animations: [
    // trigger(
    //     'enterAnimation', [
    //         transition(':enter', [
    //             style({ height: '1px', opacity: 0 }),
    //             animate('250ms', style({ height: '324px', opacity: 1 }))
    //         ]),
    //         transition(':leave', [
    //             style({ height: '324px', opacity: 1 }),
    //             animate('250ms', style({ height: '1px', opacity: 0 }))
    //         ])
    //     ]
    // ),
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )],
    providers: [
      { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
      { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
})

export class EmailfaxlogComponent implements OnInit, OnDestroy {
  // Page constants
  PAGE_TITLE: string;

      // Drop-down lists
      customerList: CustomerSelectItem[] = [];
      equipmentList: EquipmentSelectItem[] = [];
      equipmentList_: EquipmentSelectItem[] = [];
      selectedJobsite: number[] = []; 
      jobsiteList: GenericIdName[] = [];
      // Search Filters
      selectedCustomer: number[] = [];
      selectedEquipment: number[] = [];
      startDate: Date;
      endDate: Date;
      endTime:null;
      startTime:null;
      LabNumber:string;
      Email:string;
      Username:string;
      NoImps:boolean=false;
      showMultiple:boolean=true;
      selectedEquipment_:any
      selectedEquipmentval:any
      GET_Auto:number[]=[];
      StartDateControl = new FormControl(moment());
      EndDateControl = new FormControl(moment());
        loadSize: number = 100;
  // Search options
  searchParameters: SearchEmailFaxLogItem = new SearchEmailFaxLogItem();
  // Get from server
  performSearch: boolean = false;
  searchResults: SearchEmailFaxLogItem[] = [];
  //onEq:number=3;
  performSearchImp: boolean = false;
  reset:boolean=false;
  showGraphBar:boolean=false;
  showGraphIcon:boolean=false
  @Input() searchParameters_: SearchEmailFaxLogItem = new SearchEmailFaxLogItem();

  @Output() Reset:EventEmitter<boolean> = new EventEmitter<boolean>();
  public pageNumber = 1;
  public emailLogPageSize = 25;
  public totalResults = 0;
  public emailFaxLogResults: EmailFaxLogRowViewModel[] = [];
  public retrievingEmailFaxLogResults = true;
  public selectedLogSent = 0;

  private subscriptions: Subscription[] = [];
  private lastItemsSearched!: SearchEmailFaxLogItem;

  checked = false;
  selection = new SelectionModel(true, []);
  sortOption!: SortOptions;
  emailOrder: EmailLogOrderBy = new EmailLogOrderBy(SortOptions.Email);
  logDateOrder: EmailLogOrderBy = new EmailLogOrderBy(SortOptions.LogDate, true);
  logTimeOrder: EmailLogOrderBy = new EmailLogOrderBy(SortOptions.LogTime);
  serialOrder: EmailLogOrderBy = new EmailLogOrderBy(SortOptions.SerialNumber);
  uitOrder: EmailLogOrderBy = new EmailLogOrderBy(SortOptions.UnitNumber);
  customerOrder: EmailLogOrderBy = new EmailLogOrderBy(SortOptions.Customer);
  usernameOrder: EmailLogOrderBy = new EmailLogOrderBy(SortOptions.Username);
  labNumber: EmailLogOrderBy = new EmailLogOrderBy(SortOptions.LabNumber);
  isMailSent: EmailLogOrderBy = new EmailLogOrderBy(SortOptions.IsMailSent);
  constructor(private _appService: AppService,private _crypto: CryptoService,
      public dialog: MatDialog,
      private _favouriteDialogService:FavouriteDialogService,
      private _equipmentService: GETSetupEquipmentService,
  public toastr: NotificationsService, 
  private _emailFaxLogService: EmailFaxLogService,
  private _notify: NotificationsService,
  private activatedRoute: ActivatedRoute,
  private _router: Router,) {
  
  }

  ngOnInit() {
      this._appService.setPageTitle('Search Inspection');
      this.setInitialDates();
      this.loadCustomers();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(
      subscription => {
        if (!subscription.closed) subscription.unsubscribe();
      });
  }

  setInitialDates() {
    this.startDate = this.defaultSearchStartDate;
    this.endDate = this.defaultSearchEndDate;
}
   get defaultSearchStartDate(): Date {
        const date = new Date(Date.now());
        date.setMonth(date.getMonth() - 1);
        return date;
    }

    get defaultSearchEndDate(): Date {
        const date = new Date();
        date.setDate(date.getDate() + 1);
        return date;
    }
  
  show:boolean=false
  hidematgroup:boolean=false
  initializeQueryParamterSubscription() {
    this.subscriptions.push(
      this.activatedRoute.queryParams.subscribe(
        params => {
          const pageNumber: number = params['page'];
          const emailLogPageSize: number = params['display'];
          if (pageNumber != null) {
            this.pageNumber = pageNumber - 1;
          } else {
            this.pageNumber = 0;
          }

          if (emailLogPageSize != null) {
            this.emailLogPageSize = emailLogPageSize;
          } else {
            this.emailLogPageSize = 25;
          }

          this.loadInspectionResults(this.lastItemsSearched, this.logDateOrder);
      })
    );
  }

  public loadInspectionResults(params: SearchEmailFaxLogItem, orderby: EmailLogOrderBy) {
    this.retrievingEmailFaxLogResults = true;
    this.lastItemsSearched = params;
    this.subscriptions.push(this._emailFaxLogService
      .getEmailFaxLogs(this.pageNumber, this.emailLogPageSize, params, orderby)
      .subscribe(
        results => {
          this.emailFaxLogResults = results.emailFaxLogResult;
          this.emailFaxLogResults.forEach((e: any) => {
            if (e?.SentToAddress && e.SentToAddress.length > 0) {
              e.SentToAddress = this._crypto.decrypt(e.SentToAddress);
            }
          });
          this.totalResults = results.TotalRecords;
          this.retrievingEmailFaxLogResults = false;
        },
        error => {
          console.log(error);
          this._notify.error('Error', 'Unable to search for Implement inspections. Please contact TrackTreads support if this error continues to happen. ');
        },
        () => {
          this.retrievingEmailFaxLogResults = false;
        })
    );
  }

  loadJobsitesForCustomer() {
    if (this.selectedCustomer == null)
        return;
    this.selectedJobsite = null;
    this.jobsiteList = null;
    this.selectedEquipment = null;
    this.equipmentList = [];
    var params: JobsiteSelectionFilter = {
        Customers: this.selectedCustomer,
      }
    this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
        if (r) {
         
            this.jobsiteList = r;
            this.selectedJobsite=r.map(x=>x.Id);
            this.loadEquipmentForJobsite();
        }
      });
      
}

loadEquipmentForJobsite() {

  if (this.selectedJobsite == null)
      return;
  var params: number[] = this.selectedJobsite;
  this._favouriteDialogService.GetEquipmentAvailable(params).subscribe(r => {
      if (r) {
          this.equipmentList = r;
          this.equipmentList_=r
      }
  });
}

  submitSelection() {
this.performSearch = true;
this.performSearchImp=true;
this.hidematgroup=false;
    var params: SearchEmailFaxLogItem = {
        customer: this.selectedCustomer,
        equipment: this.selectedEquipment,
        Email: this.Email,
        Username:this.Username,
        LabNumber:this.LabNumber,
        LogSentType:this.selectedLogSent,
        startDate:this.startDate.toISOString(),
        endDate:this.endDate.toISOString(),
        PageNo:this.pageNumber,
        PageSize:this.emailLogPageSize
    }
    this.loadInspectionResults(params, this.logDateOrder);
    
}

isAllSelected() {
  const numSelected = this.selection.selected.length;
  const numRows = this.emailFaxLogResults.length;
  return numSelected === numRows;
}

masterToggle() {
  this.isAllSelected() ?
      this.selection.clear() :
      this.emailFaxLogResults.forEach(row => this.selection.select(row));
}

onPageEvent(event: PageEvent) {
    this.pageNumber = event.pageIndex;
    this.emailLogPageSize = event.pageSize;

    this.pageNumber= this.pageNumber;
    // this.updateQueryParams();

    this.submitSelection();
  }


  loadCustomers() {
    // this.familyList  = this. _favouriteDialogService.availableFamilyList 
     this._equipmentService.getCustomerList().subscribe(r => {
         this.customerList = r;
     });
 }


     filteredFamilies:GenericIdName[]=[];


  ResetFields(){
      this.hidematgroup=true;
        this.selectedCustomer=[];
        this.selectedCustomer=[];
        this.selectedEquipment=[];
        this.selectedEquipment_=''
        this.selectedLogSent= null
        this.selectedEquipment_=null       
        this.showMultiple= true
        this.Username="";
        this.Email="";
        this.LabNumber="";
        this.reset=true;
        this.Reset.emit(this.reset);
        this.setInitialDates();
        //this.ref.detectChanges();
  }

  updateQueryParams() {
    const queryParams: Params = Object.assign({}, this.activatedRoute.snapshot.queryParams);
    queryParams['page'] = this.pageNumber + 1;
    queryParams['display'] = this.emailLogPageSize;
    this._router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: queryParams
      });
  }

  showGraphsBar(){
      this.showGraphBar=!this.showGraphBar
    }  

    changeModelAutoComplete(event:any){
        const filterValue = event.target.value.toLowerCase();
     
        this.equipmentList = this.equipmentList_.filter(option => option.SerialNumber.toLowerCase().includes(filterValue));
      }


    ShowHidefield(){
        this.selectedEquipment=[]
        this.selectedEquipment_=''
        this.selectedEquipment_=null
        this.selectedEquipment_=""
        this.selectedEquipment_=0      
        
        this.showMultiple=!this.showMultiple;
    }

    sortBy(sortOption: string) {
      const selectedOptions = SortOptions[sortOption];
      switch (selectedOptions) {
        case SortOptions.Email:
          this.emailOrder.selected = !this.emailOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.emailOrder);
          break;
        case SortOptions.LogDate:
          this.logDateOrder.selected = !this.logDateOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.logDateOrder);
          break;
        case SortOptions.LogTime:
            this.logDateOrder.selected = !this.logDateOrder.selected;
            this.loadInspectionResults(this.lastItemsSearched, this.logDateOrder);
            break;
        case SortOptions.SerialNumber:
          this.serialOrder.selected = !this.serialOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.serialOrder);
          break;
        case SortOptions.UnitNumber:
          this.uitOrder.selected = !this.uitOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.uitOrder);
          break;
        case SortOptions.Customer:
          this.customerOrder.selected = !this.customerOrder.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.customerOrder);
          break;
        case SortOptions.LabNumber:
          this.labNumber.selected = !this.labNumber.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.labNumber);
          break;
          case SortOptions.IsMailSent:
          this.isMailSent.selected = !this.isMailSent.selected;
          this.loadInspectionResults(this.lastItemsSearched, this.isMailSent);
          break;
          case SortOptions.Username:
            this.usernameOrder.selected = !this.usernameOrder.selected;
            this.loadInspectionResults(this.lastItemsSearched, this.usernameOrder);
            break;
      }
  
    }

}

